export const view = (component: string) => {
    return import(`@/views/${component}.vue`);
};
